import { render, staticRenderFns } from "./MaterialSensitivity.vue?vue&type=template&id=2c8832b6"
import script from "./MaterialSensitivity.vue?vue&type=script&lang=js"
export * from "./MaterialSensitivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports